/* eslint-disable @angular-eslint/no-output-on-prefix */
import { CdkStepper } from '@angular/cdk/stepper';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IStepModel } from './models/step.model';

@Component({
  selector: 'app-custom-stepper',
  templateUrl: './custom-stepper.component.html',
  styleUrls: ['./custom-stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: CustomStepperComponent }],
})
export class CustomStepperComponent
  extends CdkStepper
  implements OnInit, OnChanges
{
  @Input() stepperSteps?: Array<IStepModel>;
  @Input() isLoading = false;

  @Output() onSubmitEvent: EventEmitter<any> = new EventEmitter();
  @Output() onCloseEvent: EventEmitter<any> = new EventEmitter();
  @Output() onNextEvent: EventEmitter<any> = new EventEmitter();

  title?: string;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setStepTitle();
  }

  goToNext(): void {
    this.selectedIndex = this.selectedIndex + 1;
    this.setStepTitle();
  }

  goToPrevious(): void {
    this.selectedIndex = this.selectedIndex - 1;
    this.setStepTitle();
  }

  onNext() {
    this.onNextEvent.emit(this.selectedIndex);
  }

  onPrevious() {
    if (this.selectedIndex === 0) {
      this.onCloseEvent.emit();
    } else {
      this.goToPrevious();
    }
  }

  onSubmit() {
    this.onSubmitEvent.emit();
  }

  isLastStep(): boolean {
    return this.selectedIndex === this.steps.length - 1;
  }

  setStepTitle(): void {
    if (this.stepperSteps && this.stepperSteps.length > 0) {
      this.title = this.stepperSteps[this.selectedIndex].titleKey;
    }
  }
}
